import React from 'react';
import PropTypes from 'prop-types';
import { renderImage as renderDynamicImage } from 'helpers/ImageHelper';

const PersonalityBio = ({ item, style, personalityTabSlug }) => {
  const { description, name, images, id } = item;

  const renderImage = image => {
    if (!image) return null;
    const imageUrl = image.raw;
    return (
      <div className={style.personalityBioImage}>
        {renderDynamicImage({
          alt: name,
          src: imageUrl,
        })}
      </div>
    );
  };

  return (
    <div id={personalityTabSlug} data-tab-id={id} className={style.personalityBioContainer}>
      <div className={style.personalityBioName}>{name}</div>
      <div className={style.personalityBioImage}>{renderImage(images.still)}</div>
      <div className={style.personalityBioDescription}>{description}</div>
    </div>
  );
};

PersonalityBio.defaultProps = {
  item: {},
  personalityTabSlug: '',
  style: {},
};

PersonalityBio.propTypes = {
  item: PropTypes.shape({}),
  personalityTabSlug: PropTypes.string,
  style: PropTypes.shape({}),
};

export default PersonalityBio;
